import { Check } from "lucide-react";

// Minimal, premium live MOQ progress (no animations, no popups, no circles).
// MOQ is shared across single fragrances + duets of the same bottle size.
export const MoqProgress = ({ total = 0, moq = 1, className = "" }) => {
  if (!moq || moq < 1) return null;
  const met = total >= moq;
  const remaining = Math.max(0, moq - total);

  if (met) {
    return (
      <p data-testid="moq-progress-complete" className={`flex items-center gap-1.5 font-mono-label text-[11px] uppercase tracking-[0.18em] text-[#C5A059] ${className}`}>
        <Check className="w-3.5 h-3.5 shrink-0" strokeWidth={2.4} /> Minimum Order Complete
      </p>
    );
  }

  return (
    <div data-testid="moq-progress-incomplete" className={`font-mono-label ${className}`}>
      <p className="text-[11px] uppercase tracking-[0.15em] text-[#F4EFE6]">
        <span className="text-[#C5A059]">{total}</span> of {moq} Bottles Added
      </p>
      <p className="text-[10px] tracking-wider text-white/50 mt-0.5">{remaining} more bottle{remaining !== 1 ? "s" : ""} required</p>
    </div>
  );
};

export default MoqProgress;
